import React from "react";
import { Formik } from "formik";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  intlShape,
  isEmpty,
  isNotEmpty,
  ActionBar,
  CancelButton,
  SubmitButton,
  withBackend,
  backendShape,
  withNotifier,
  withBrowser,
  notifierShape,
  browserShape,
  withApi,
  apiShape,
  FilesUpload,
} from "lcm-iot-commons";

type Props = {
  intl: intlShape;
  backend: backendShape;
  notifier: notifierShape;
  browser: browserShape;
  api: apiShape;
  match: {
    params?: {
      subscription_id?: string;
      id?: string;
    };
  };
};

export function OpcUaServerCaCertificateUpload({
  api,
  intl,
  backend,
  match,
  browser,
  notifier,
}: Props) {
  React.useEffect(() => {
    const loadData = async () => {
      try {
        const subscription = await api.get(
          `/api_subscriptions/${
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            match.params.subscription_id
          }`,
        );
        // eslint-disable-next-line camelcase
        const accessRightsResponse = await api.get(
          "/users/current/access_rights",
          {
            permitable_type: "ClientApplication",
            permitable_id: subscription?.client_application.id,
          },
        );
        if (!accessRightsResponse.can_update) {
          browser.navigateTo("/403");
        }
      } catch (error) {
        notifier.showError(backend.translateError(error));
        browser.navigateTo("/403");
      }
    };
    loadData();
  }, [match]);

  const submitData = async (values: $TSFixMe, actions: $TSFixMe) => {
    await backend.upload(
      `/api_subscriptions/${
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        match.params.subscription_id
      }/opc_ua_servers/${
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        match.params.id
      }/ca_certificates`,
      {
        file: values.fileUpload.acceptedFiles[0],
        name: values.fileUpload.acceptedFiles[0].name,
      },
    );
    actions.setSubmitting(false);
    notifier.showSuccess(
      intl.formatMessage({ id: "ca_cert_upload.success_notification" }),
    );
    browser.goBack();
  };

  const onSubmit = (values: $TSFixMe, actions: $TSFixMe) => {
    submitData(values, actions).catch((apiErrors) => {
      notifier.showError(backend.translateError(apiErrors));
      actions.setErrors(apiErrors);
      actions.setSubmitting(false);
    });
  };

  const validateForm = (values: $TSFixMe) => {
    const errors = {};

    if (
      !values.fileUpload ||
      (isEmpty(values.fileUpload.acceptedFiles) &&
        isEmpty(values.fileUpload.rejectedFiles))
    ) {
      (errors as $TSFixMe).fileUpload = intl.formatMessage({
        id: "ca_cert_upload.file.mandatory",
      });
    }

    if (values.fileUpload && isNotEmpty(values.fileUpload.rejectedFiles)) {
      (errors as $TSFixMe).fileUpload = intl.formatMessage({
        id: "ca_cert_upload.dropzone.rejection",
      });
    }

    return errors;
  };

  const renderForm = (formProps: $TSFixMe) => {
    const { handleSubmit, isSubmitting, setStatus } = formProps;

    /* istanbul ignore next */
    const beforeHandleSubmit = (event: $TSFixMe) => {
      /* istanbul ignore next */
      setStatus("submitted");
      /* istanbul ignore next */
      handleSubmit(event);
    };

    return (
      <form onSubmit={beforeHandleSubmit} noValidate>
        <FilesUpload
          {...formProps}
          name="fileUpload"
          multiple={false}
          whiteList={[".der"]}
        />
        <div className="btn-group">
          <SubmitButton
            id="opc-ua-server-ca-cert-upload-submit"
            fetching={isSubmitting}
          />
          <CancelButton
            id="opc-ua-server-ca-cert-upload-cancel"
            // @ts-expect-error TS(2322) FIXME: Type '{ id: string; disabled: any; }' is not assig... Remove this comment to see the full error message
            disabled={isSubmitting}
          />
        </div>
      </form>
    );
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <ActionBar>
            <h1>
              <FormattedMessage id="ca_cert_upload.header" />
            </h1>
          </ActionBar>
        </div>
      </div>
      <div className="row">
        <div id="opc-ua-server-ca-cert-upload-details" className="col-sm-6">
          <Formik
            initialValues={{}}
            validate={validateForm}
            onSubmit={onSubmit}
          >
            {renderForm}
          </Formik>
        </div>
      </div>
    </div>
  );
}

export default injectIntl(
  withBrowser(
    withApi(withNotifier(withBackend(OpcUaServerCaCertificateUpload))),
  ),
);
